import { z } from 'zod';

// Shared attribute schema
const AiScoringAttributeSchema = z.object({
  label: z.string(),
  description: z.string(),
  attribute_type: z.string().nullable(),
  is_negative: z.boolean().optional().default(false),
  is_valid: z.union([z.boolean(), z.null()]).default(false),
  reason: z.string().nullable().optional(),
  valid_type: z.enum(['error', 'warning', 'success']).nullable().optional(),
  position: z.number().int(),
  weight: z.union([z.number(), z.string()]).transform((val) => {
    if (typeof val === 'string') {
      const num = parseFloat(val);
      return isNaN(num) ? 0 : num;
    }
    return val;
  }),
  id: z.union([z.number().int(), z.string()]).nullable().optional(),
  // this is for temporary attributes that are created in ui and not saved to db
  isNewAttribute: z.boolean().optional().default(false),
});

export const AiScoringSchemas = {
  AiScoringAttributeSchema,
};
